module.exports = __webpack_public_path__ + "static/media/React-logo.8ab12c49.png";